import SettingsIndex from '@/views/Settings/SettingsIndex.vue';
import AppSettingsIndex from '@/views/Settings/AppSettings/AppSettingsIndex.vue';
import BrandSettingsIndex from '@/views/Settings/BrandSettings/BrandSettingsIndex.vue';
import DebtCompanyIndex from '@/views/Settings/DebtCompany/DebtCompanyIndex.vue';
import CronjobIndex from '@/views/Settings/Cronjob/CronjobIndex.vue';
import MonitorIndex from '@/views/Settings/Monitor/MonitorIndex.vue';
import WaterfallFilterIndex from '@/views/Settings/WaterfallFilter/WaterfallFilterIndex.vue';
import AdverseActionIndex from '@/views/Settings/AdverseAction/AdverseActionIndex.vue';
import SlackChannelIndex from '@/views/Settings/SlackChannel/SlackChannelIndex.vue';
import TrackedJobsIndex from '@/views/Settings/TrackedJobs/TrackedJobsIndex.vue';
import ThirdPartyServiceHealthIndex from '@/views/Settings/ThirdPartyServiceHealth/ThirdPartyServiceHealthIndex.vue';

export default [
  {
    path: 'settings',
    name: 'settings',
    component: SettingsIndex,
    meta: {
      title: 'Settings',
      permission: 'view system-settings',
    },
    children: [
      {
        path: 'app-settings',
        name: 'app-settings',
        component: AppSettingsIndex,
        meta: {
          title: 'App Settings',
          permission: 'view system-settings::app-settings',
        },
      },
      {
        path: 'brand-settings',
        name: 'brand-settings',
        component: BrandSettingsIndex,
        meta: {
          title: 'Brand Settings',
          permission: 'view system-settings::brand-settings',
        },
      },
      {
        path: 'debt-company-settings',
        name: 'debt-company-settings',
        component: DebtCompanyIndex,
        meta: {
          title: 'Debt Company Settings',
          permission: 'view system-settings::brand-settings',
        },
      },
      {
        path: 'cronjobs',
        name: 'cronjobs',
        component: CronjobIndex,
        meta: {
          title: 'Cron Jobs',
          permission: 'view system-settings::cron-jobs',
        },
      },
      {
        path: 'monitors',
        name: 'monitors',
        component: MonitorIndex,
        meta: {
          title: 'Monitors',
          permission: 'view system-settings::monitors',
        },
      },
      {
        path: 'waterfall-filter',
        name: 'waterfall-filter',
        component: WaterfallFilterIndex,
        meta: {
          title: 'Waterfall Filters',
          permission: 'view system-settings::waterfall-filters',
        },
      },
      {
        path: 'adverse-action',
        name: 'adverse-action',
        component: AdverseActionIndex,
        meta: {
          title: 'Adverse Action',
          permission: 'view system-settings::adverse-action',
        },
      },
      {
        path: 'slack-channels',
        name: 'slack-channels',
        component: SlackChannelIndex,
        meta: {
          title: 'Slack Channels',
          permission: 'view system-settings::slack-channels',
        },
      },
      {
        path: 'tracked-jobs',
        name: 'tracked-jobs',
        component: TrackedJobsIndex,
        meta: {
          title: 'Tracked Jobs',
          permission: 'view system-settings::tracked-jobs',
        },
      },
      {
        path: 'third-party-service-health',
        name: 'third-party-service-health',
        component: ThirdPartyServiceHealthIndex,
        meta: {
          title: 'Third Party Service Health',
          permission: 'view system-settings::third-party-health',
        },
      },
    ],
  },
];
